import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Header from "../Components/Header";
import BreadcrumbMain from "../Components/BreadcrumbMain";
import heroImg from '../Images/contact-breadcrumb.webp'
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { services } from "../Data";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useRecaptcha } from "../Components/ReCaptcha";
import SchemaMarkup from "../Components/SchemaMarkup";
import breadcrumbSchema from '../Schemas/breadcrumbSchema'

const Contact=()=>{
     useEffect(() => {
            document.title =
              "Contact LDL Settlement Services Perth";
        
            const metaDesc = document.querySelector("meta[name='description']");
            if (metaDesc) {
              metaDesc.setAttribute(
                "content",
                "Contact LDL Settlement Services for trusted property settlement assistance across Perth and Western Australia."
              );
            }
        
            const canonical = document.querySelector("link[rel='canonical']");
          if (canonical) {
            canonical.setAttribute("href", "https://ldlsettlementservices.com.au/contact-us");
          }
        
          const ogTitle = document.querySelector("meta[property='og:title']");
          if (ogTitle) {
            ogTitle.setAttribute(
              "content",
              "Contact LDL Settlement Services Perth"
            );
          }
        
            const ogDesc = document.querySelector("meta[property='og:description']");
          if (ogDesc) {
            ogDesc.setAttribute(
              "content",
              "Contact LDL Settlement Services for trusted property settlement assistance across Perth and Western Australia."
            );
          }
        
          const ogUrl = document.querySelector("meta[property='og:url']");
          if (ogUrl) {
            ogUrl.setAttribute("content", "https://ldlsettlementservices.com.au/contact-us");
          }
        
            const ogImage = document.querySelector("meta[property='og:image']");
          if (ogImage) {
            ogImage.setAttribute(
              "content",
              "https://ldlsettlementservices.com.au/Images/contact-img.webp"
            );
          }
        
            const twitterTitle = document.querySelector("meta[name='twitter:title']");
          if (twitterTitle) {
            twitterTitle.setAttribute(
              "content",
              "Contact LDL Settlement Services Perth"
            );
          }
        
            const twitterDesc = document.querySelector(
            "meta[name='twitter:description']"
          );
          if (twitterDesc) {
            twitterDesc.setAttribute(
              "content",
              "Contact LDL Settlement Services for trusted property settlement assistance across Perth and Western Australia."
            );
          }
        
            const twitterImage = document.querySelector("meta[name='twitter:image']");
          if (twitterImage) {
            twitterImage.setAttribute(
              "content",
              "https://ldlsettlementservices.com.au/Images/contact-img.webp"
            );
          }
          }, []);

const breadcrumbs = breadcrumbSchema([
  {
    name: "Home",
    url: "https://ldlsettlementservices.com.au/"
  },
  {
    name: "Contact Us"
  }
]);
      
   const [loading, setLoading] = useState(false);
   const generateToken = useRecaptcha();

const [formData, setFormData] = useState({
  name: "",
  email: "",
  phoneNumber: "",
  service: "",
  message: "",
});

const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
};

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.name)
    return toast.error("Please enter your name");

  if (!formData.email)
    return toast.error("Please enter email address");

  if (!formData.phoneNumber)
    return toast.error("Please enter phone number");

  if (!formData.service)
    return toast.error("Please select a service");

  if (!formData.message)
    return toast.error("Please enter message");

  const phoneRegex = /^[0-9]{8,15}$/;

  if (!phoneRegex.test(formData.phoneNumber)) {
    return toast.error("Enter valid phone number");
  }

  setLoading(true);
  

  generateToken(async (token) => {
    try {

      // RECAPTCHA VERIFY

      const recaptchaData = new FormData();

      recaptchaData.append(
        "secret",
        "6LdQeRwtAAAAAJF7CHdPYH3dCyF2g2-mdQc_SSAn"
      );

      recaptchaData.append(
        "response",
        token
      );

      const verifyRes = await axios.post(
        "https://api.sendmail.adhyaynam.in/recaptcha-verify",
        recaptchaData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log(
        "FULL RESPONSE:",
        verifyRes.data
      );

      const score =
        verifyRes.data.score ||
        verifyRes.data.data?.score;

      console.log(
        "Recaptcha Score:",
        score
      );

      if (!score || score <= 0.5) {

        toast.error(
          "Spam detected. Please try again."
        );

        setLoading(false);

        return;
      }

   const template = `

<div
  style="
    margin:0;
    padding:40px 0;
    background:#F5F6F8;
    font-family:Poppins,Arial,sans-serif;
  "
>

  <table
    width="100%"
    cellpadding="0"
    cellspacing="0"
    border="0"
  >

<tr>
  <td align="center">

    <table
      width="680"
      cellpadding="0"
      cellspacing="0"
      border="0"
      style="
        background:#ffffff;
        border-radius:20px;
        overflow:hidden;
        box-shadow:0 15px 45px rgba(0,0,0,0.08);
      "
    >

      <tr>

        <td
          style="
            background:#18263C;
            padding:40px;
            text-align:center;
          "
        >

        <img
            src="https://ldlsettlementservices.com.au/logo.png"
            alt="LDL Settlement Services Logo"
            style="
              max-width:220px;
              display:block;
              margin:0 auto 24px;
            "
          />

          <div
            style="
              width:80px;
              height:2px;
              background:#A88B53;
              margin:0 auto 24px;
            "
          ></div>

          <h1
            style="
              margin:0;
              color:#ffffff;
              font-size:30px;
              font-weight:600;
              letter-spacing:0.5px;
            "
          >
            New Website Enquiry
          </h1>

          <p
            style="
              margin:14px 0 0;
              color:#E3DAC9;
              font-size:15px;
              line-height:1.8;
            "
          >
            A new enquiry has been submitted through
            the LDL Settlement Services website.
          </p>

        </td>

      </tr>

      <tr>

        <td style="padding:40px;">

          <table
            width="100%"
            cellpadding="0"
            cellspacing="0"
            style="
              border:1px solid #E3DAC9;
              border-radius:16px;
              overflow:hidden;
            "
          >

            <tr>

              <td
                style="
                  background:#18263C;
                  padding:18px 24px;
                "
              >

                <h2
                  style="
                    margin:0;
                    color:#ffffff;
                    font-size:18px;
                    font-weight:600;
                  "
                >
                  Lead Information
                </h2>

              </td>

            </tr>

            <tr>

              <td style="padding:30px;">

                <table width="100%">

                  <tr>

                    <td
                      width="50%"
                      style="
                        padding-bottom:24px;
                        vertical-align:top;
                      "
                    >

                      <span
                        style="
                          color:#777;
                          font-size:12px;
                          letter-spacing:1px;
                        "
                      >
                        FULL NAME
                      </span>

                      <br/>

                      <strong
                        style="
                          font-size:16px;
                          color:#18263C;
                        "
                      >
                        ${formData.name}
                      </strong>

                    </td>

                    <td
                      width="50%"
                      style="
                        padding-bottom:24px;
                        vertical-align:top;
                      "
                    >

                      <span
                        style="
                          color:#777;
                          font-size:12px;
                          letter-spacing:1px;
                        "
                      >
                        PHONE NUMBER
                      </span>

                      <br/>

                      <strong
                        style="
                          font-size:16px;
                          color:#18263C;
                        "
                      >
                        ${formData.phoneNumber}
                      </strong>

                    </td>

                  </tr>

                  <tr>

                    <td
                      width="50%"
                      style="
                        padding-bottom:24px;
                        vertical-align:top;
                      "
                    >

                      <span
                        style="
                          color:#777;
                          font-size:12px;
                          letter-spacing:1px;
                        "
                      >
                        EMAIL ADDRESS
                      </span>

                      <br/>

                      <strong
                        style="
                          font-size:16px;
                          color:#18263C;
                        "
                      >
                        ${formData.email}
                      </strong>

                    </td>

                    <td
                      width="50%"
                      style="
                        padding-bottom:24px;
                        vertical-align:top;
                      "
                    >

                      <span
                        style="
                          color:#777;
                          font-size:12px;
                          letter-spacing:1px;
                        "
                      >
                        SERVICE REQUIRED
                      </span>

                      <br/>

                      <strong
                        style="
                          font-size:16px;
                          color:#18263C;
                        "
                      >
                        ${formData.service}
                      </strong>

                    </td>

                  </tr>

                </table>

              </td>

            </tr>

          </table>

        </td>

      </tr>

      <tr>

        <td style="padding:0 40px 40px;">

          <table
            width="100%"
            cellpadding="0"
            cellspacing="0"
            style="
              border:1px solid #E3DAC9;
              border-radius:16px;
              overflow:hidden;
            "
          >

            <tr>

              <td
                style="
                  background:#F8F5EF;
                  padding:18px 24px;
                  border-bottom:1px solid #E3DAC9;
                "
              >

                <h2
                  style="
                    margin:0;
                    color:#18263C;
                    font-size:18px;
                    font-weight:600;
                  "
                >
                  Client Message
                </h2>

              </td>

            </tr>

            <tr>

              <td
                style="
                  padding:30px;
                  color:#0F1826;
                  font-size:15px;
                  line-height:2;
                "
              >

              ${formData.message}

              </td>

            </tr>

          </table>

        </td>

      </tr>

      <tr>

        <td
          style="
            background:#18263C;
            text-align:center;
            padding:35px;
          "
        >

          <div
            style="
              width:80px;
              height:2px;
              background:#A88B53;
              margin:0 auto 24px;
            "
          ></div>

          <p
            style="
              margin:0;
              color:#ffffff;
              font-size:15px;
              font-weight:500;
            "
          >
            LDL Settlement Services
          </p>

          <p
            style="
              margin:10px 0 0;
              color:#E3DAC9;
              font-size:13px;
              line-height:1.8;
            "
          >
            Trusted Property Settlement Solutions
            Across Western Australia
          </p>

        </td>

      </tr>

    </table>

  </td>
</tr>
  </table>

</div>
`;


    const data = new FormData();

    data.append(
      "title",
      "LDL Settlement Services Contact Form"
    );

    data.append(
      "to_email",
      "admin@ldlsettlementservices.com.au"
    );

    data.append(
      "cc",
      "arkayappsseo@gmail.com,sales@arkayapps.com"
    );

    data.append(
      "subject",
      "LDL Website Contact Lead"
    );

    data.append(
      "template",
      template
    );

    await axios.post(
      "https://api.sendmail.adhyaynam.in/send-mail/two",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    toast.success(
      "Message sent successfully!"
    );

    setFormData({
      name: "",
      email: "",
      phoneNumber: "",
      service: "",
      message: "",
    });

    } catch (error) {

      console.log(
        error.response?.data || error
      );

      toast.error(
        "Verification failed. Please try again!"
      );

    } finally {

      setLoading(false);

    }

  });

};
    return(
        <>

<SchemaMarkup schema={breadcrumbs} />

          {/**HEADER */}
         <Header
        showBreadcrumb={true}
        pageName="Contact us"
      />

      {/**HERO SECTION */}
       <BreadcrumbMain
      subTitle="CONTACT US"
      title="We are Here to Help
Get in Touch."
      description="Have a Question or ready to get started ? Our Friendly Team is here to assist with all your settlement needs."
      image={heroImg}
      showIcons={false}
    />

    {/**FORM SECTION */}

   <section className="contact-form-section container">

  {/* LEFT FORM */}

  <motion.div
    className="contact-form-wrapper"
    initial={{
      opacity: 0,
      x: -70,
    }}
    whileInView={{
      opacity: 1,
      x: 0,
    }}
    transition={{
      duration: 1,
      ease: [0.22, 1, 0.36, 1],
    }}
    viewport={{
      once: true,
      amount: 0.15,
    }}
  >

    <motion.h2
      className="section-heading"
      initial={{
        opacity: 0,
        y: 35,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      transition={{
        duration: 0.85,
        ease: [0.22, 1, 0.36, 1],
      }}
      viewport={{
        once: true,
      }}
    >
      Send us a Message
    </motion.h2>

    <motion.p
      className="section-text contact-top-text"
      initial={{
        opacity: 0,
        y: 35,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      transition={{
        duration: 0.95,
        delay: 0.1,
        ease: [0.22, 1, 0.36, 1],
      }}
      viewport={{
        once: true,
      }}
    >
      Fill out the form below and we’ll get back to you as soon as possible
    </motion.p>

    <motion.form
    onSubmit={handleSubmit}
      className="contact-form"
      initial="hidden"
      whileInView="visible"
      viewport={{
        once: true,
        amount: 0.15,
      }}
      variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.1,
          },
        },
      }}
    >

      {/* ROW 1 */}

      <div className="form-row">

        <motion.div
          className="form-group"
          variants={{
            hidden: {
              opacity: 0,
              y: 35,
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.75,
                ease: [0.22, 1, 0.36, 1],
              },
            },
          }}
        >

          <label>
            Full Name *
          </label>

          <motion.input
           type="text"
  name="name"
  value={formData.name}
  onChange={handleChange}
            placeholder="Enter your Full Name"
            whileFocus={{
              scale: 1.01,
            }}
            transition={{
              duration: 0.25,
            }}
          />

        </motion.div>

        <motion.div
          className="form-group"
          variants={{
            hidden: {
              opacity: 0,
              y: 35,
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.75,
                ease: [0.22, 1, 0.36, 1],
              },
            },
          }}
        >

          <label>
            Email Address *
          </label>

          <motion.input
            type="email"
  name="email"
  value={formData.email}
  onChange={handleChange}
  placeholder="Enter Email Address"
            whileFocus={{
              scale: 1.01,
            }}
            transition={{
              duration: 0.25,
            }}
          />

        </motion.div>

      </div>

      {/* ROW 2 */}

      <div className="form-row">

        <motion.div
          className="form-group"
          variants={{
            hidden: {
              opacity: 0,
              y: 35,
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.75,
                ease: [0.22, 1, 0.36, 1],
              },
            },
          }}
        >

          <label>
            Phone Number *
          </label>

          <motion.input
            type="text"
  name="phoneNumber"
  value={formData.phoneNumber}
  onChange={handleChange}
  placeholder="Enter your Contact Number"
            whileFocus={{
              scale: 1.01,
            }}
            transition={{
              duration: 0.25,
            }}
          />

        </motion.div>

        <motion.div
          className="form-group"
          variants={{
            hidden: {
              opacity: 0,
              y: 35,
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.75,
                ease: [0.22, 1, 0.36, 1],
              },
            },
          }}
        >

          <label>
            Service *
          </label>

          <motion.select
          name="service"
           value={formData.service}
  onChange={handleChange}
            whileFocus={{
              scale: 1.01,
            }}
            transition={{
              duration: 0.25,
            }}
          >

            <option value="">
              Select the Service you are looking for
            </option>

          {services.map((item, i) => (
    <option
      key={i}
      value={item.title}
    >
      {item.title}
    </option>
  ))}
           

          </motion.select>

        </motion.div>

      </div>

      {/* MESSAGE */}

      <motion.div
        className="form-group"
        variants={{
          hidden: {
            opacity: 0,
            y: 35,
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.75,
              ease: [0.22, 1, 0.36, 1],
            },
          },
        }}
      >

        <label>
          Message *
        </label>

        <motion.textarea
         name="message"
  value={formData.message}
  onChange={handleChange}
  placeholder="Enter your Message"
          whileFocus={{
            scale: 1.01,
          }}
          transition={{
            duration: 0.25,
          }}
        />

      </motion.div>

      {/* BTN */}

      <motion.button
  type="submit"
  disabled={loading}
  className="secondary-btn contact-submit-btn"
>
  {loading
    ? "Sending..."
    : "Send Message"}
</motion.button>

    </motion.form>

  </motion.div>

  {/* RIGHT INFO */}

  <motion.div
    className="contact-info-wrapper"
    initial={{
      opacity: 0,
      x: 70,
    }}
    whileInView={{
      opacity: 1,
      x: 0,
    }}
    transition={{
      duration: 1,
      ease: [0.22, 1, 0.36, 1],
    }}
    viewport={{
      once: true,
      amount: 0.15,
    }}
  >

    <motion.h2
      className="section-heading"
      initial={{
        opacity: 0,
        y: 35,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      transition={{
        duration: 0.85,
        ease: [0.22, 1, 0.36, 1],
      }}
      viewport={{
        once: true,
      }}
    >
      Contact Information
    </motion.h2>

    <motion.p
      className="section-text contact-top-text"
      initial={{
        opacity: 0,
        y: 35,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      transition={{
        duration: 0.95,
        delay: 0.1,
        ease: [0.22, 1, 0.36, 1],
      }}
      viewport={{
        once: true,
      }}
    >
      Reach out to us for any Inquiries,
      Quotations, or Support.
      <br />
      We will get back to you as soon as possible.
    </motion.p>

    <motion.div
      className="contact-line"
      initial={{
        width: 0,
        opacity: 0,
      }}
      whileInView={{
        width: "100%",
        opacity: 1,
      }}
      transition={{
        duration: 1,
        ease: [0.22, 1, 0.36, 1],
      }}
      viewport={{
        once: true,
      }}
    />

    {[
    {
  icon: <FaPhoneAlt />,
  title: "Phone",
  content: (
    <>
      <a
        href="tel:0861566225"
        className="section-text contact-phone"
      >
        (08) 6156 6225
      </a>

      <a
        href="tel:0420360030"
        className="section-text contact-phone"
      >
        04 2036 0030
      </a>
    </>
  ),
},
      {
        icon: <FaEnvelope />,
        title: "Email",
        content: (
          <a
            href="mailto:admin@ldlsettlementservices.com.au"
            className="section-text"
          >
            admin@ldlsettlementservices.com.au
          </a>
        ),
      },
      {
        icon: <FaMapMarkerAlt />,
        title: "Address",
        content: (
          <p className="section-text">
            220 Carr Place
            <br />
            Leederville WA 6007
          </p>
        ),
      },
      {
        icon: <FaMapMarkerAlt />,
        title: "Mailing Address",
        content: (
          <p className="section-text">
            PO Box 99
            <br />
            Leederville WA 6902
          </p>
        ),
      },
    ].map((item, i) => (

      <motion.div
        className="contact-info-item"
        key={i}
        initial={{
          opacity: 0,
          y: 35,
        }}
        whileInView={{
          opacity: 1,
          y: 0,
        }}
        transition={{
          duration: 0.8,
          delay: i * 0.12,
          ease: [0.22, 1, 0.36, 1],
        }}
        viewport={{
          once: true,
        }}
        whileHover={{
          x: 6,
        }}
      >

        <motion.div
          className="contact-icon-box"
          whileHover={{
            rotate: -6,
            scale: 1.08,
          }}
          transition={{
            duration: 0.35,
          }}
        >
          {item.icon}
        </motion.div>

        <div className="contact-info-content">

          <h3 className="card-heading">
            {item.title}
          </h3>

          {item.content}

        </div>

      </motion.div>

    ))}

  </motion.div>

</section>

      {/**MAP SECTION */}
      <motion.section
  className="map-section"
  initial={{
    opacity: 0,
  }}
  whileInView={{
    opacity: 1,
  }}
  transition={{
    duration: 1,
    ease: [0.22, 1, 0.36, 1],
  }}
  viewport={{
    once: true,
    amount: 0.15,
  }}
>

  {/* OVERLAY */}

  <motion.div
    className="map-overlay"
    initial={{
      opacity: 0,
    }}
    whileInView={{
      opacity: 1,
    }}
    transition={{
      duration: 1.2,
      delay: 0.2,
      ease: [0.22, 1, 0.36, 1],
    }}
    viewport={{
      once: true,
    }}
  />

  {/* MAP */}

  <motion.iframe
    title="LDL Settlement Services Location"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3385.879973991336!2d115.84022937599633!3d-31.937015874025956!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2a32a54843f6ce19%3A0x577f49e939cd8497!2sLDL%20Settlement%20Services!5e0!3m2!1sen!2sin!4v1779874237843!5m2!1sen!2sin"
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    initial={{
      scale: 1.08,
      opacity: 0,
    }}
    whileInView={{
      scale: 1,
      opacity: 1,
    }}
    transition={{
      duration: 1.4,
      ease: [0.22, 1, 0.36, 1],
    }}
    viewport={{
      once: true,
    }}
  />
<ToastContainer
  position="top-right"
  autoClose={3000}
  hideProgressBar={false}
  newestOnTop
  closeOnClick
  pauseOnHover
  theme="light"
/>
</motion.section>
        </>
    )
}
export default Contact;